module.exports = __webpack_public_path__ + "static/img/pad3.1b33b5dd.png";